// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"8b600499","513":"162437fe","698":"edcbfe9b"}[chunkId] + ".chunk.css";
};